import React from "react";

import { ReactComponent as DashboardMenuItemIcon } from "../assets/svg/dashboard-menu-item-icon.svg";
import { ReactComponent as ReportingMenuItemIcon } from "../assets/svg/reporting-menu-item-icon.svg";

export const MENU_ICONS = Object.freeze({
  dashboard: <DashboardMenuItemIcon />,
  reports: <ReportingMenuItemIcon />
});
